import React from 'react'
import './footer.css';
import { SiReactos } from 'react-icons/si';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
  <div>

   
    <div className='footer section_padding'>
      <div className='footer-container'>
        <div className='footer-column logo-column'>
          <div className='footer-logo-div'>
              <SiReactos className='footer-logo' />
              <h1 className='footer-logo-title'>CodersDane</h1>

          </div>
        </div>
        <div className='footer-column'>
          <h2 className='column-title'>COMPANY</h2>
          <ul>
            <li className='column-item'><a href='#home'>Home</a></li>
            <li className='column-item'><a href='#home'>About Us</a></li>
            <li className='column-item'><a href='#home'>Services</a></li>
            <li className='column-item'><a href='#home'>Products</a></li>
            <li className='column-item'><a href='#home'>Hire Us</a></li>
            <li className='column-item'><a href='#home'>Portfolio</a></li>
            <li className='column-item'><a href='#home'>Contact</a></li>
            <li className='column-item'><a href='#home'>Privacy</a></li>
          </ul>
        </div>

        <div className='footer-column'>
          <h2 className='column-title'>SALESFORCE</h2>
          <ul>
            <li className='column-item'><a href='#home'>Implementation</a></li>
            <li className='column-item'><a href='#home'>Application Development</a></li>
            <li className='column-item'><a href='#home'>Integration</a></li>
            <li className='column-item'><a href='#home'>Sales Marketing Cloud</a></li>
            <li className='column-item'><a href='#home'>Community Enhancement</a></li>
            <li className='column-item'><a href='#home'>Financial Services</a></li>
            <li className='column-item'><a href='#home'>Support Services</a></li>
          </ul>
        </div>

        <div className='footer-column'>
          <h2 className='column-title'>AWS</h2>
          <ul>
            <li className='column-item'><a href='#home'>DevOps</a></li>
            <li className='column-item'><a href='#home'>Solution Architecture</a></li>
            <li className='column-item'><a href='#home'>Integration and Migration</a></li>
            <li className='column-item'><a href='#home'>Support Services</a></li>
          </ul>
        </div>

        <div className='footer-column'>
          <h2 className='column-title'>MOBILE APP</h2>
          <ul>
            <li className='column-item'><a href='#home'>iOS App</a></li>
            <li className='column-item'><a href='#home'>Android App</a></li>
            <li className='column-item'><a href='#home'>React Native App</a></li>
            <li className='column-item'><a href='#home'>Flutter App</a></li>
            <li className='column-item'><a href='#home'>E-commerce App</a></li>
          </ul>
        </div>

        <div className='footer-column'>
          <h2 className='column-title'>WEB APP</h2>
          <ul>
            <li className='column-item'><a href='#home'>Full Stack</a></li>
            <li className='column-item'><a href='#home'>React js</a></li>
            <li className='column-item'><a href='#home'>Node js</a></li>
            <li className='column-item'><a href='#home'>Vue js</a></li>
            <li className='column-item'><a href='#home'>Java</a></li>
            <li className='column-item'><a href='#home'>Php</a></li>
            <li className='column-item'><a href='#home'>Python</a></li>
            <li className='column-item'><a href='#home'>Django</a></li>
            <li className='column-item'><a href='#home'>Ruby on Rails</a></li>
            <li className='column-item'><a href='#home'>MERN Stack</a></li>
          </ul>
        </div>
       
      </div>
      </div>
      <div className='bottom-footer'>
        <div className='copyright'>
          <p>© 2023 CodersDane.  All rights reserved.</p>
        </div>
        <div className='footer-social-icon'>
          <FaFacebookF className='footer-icon'/>
          <FaLinkedinIn className='footer-icon'/>
          <FaTwitter className='footer-icon'/>
        </div>
      </div>
  </div>
 )
}

export default Footer